export class AssetSetting {
	key: number;
	label?: string;
	order: number;
	token: string;
	name: string;
	required: boolean;
	fallback: string;

	constructor(options: { key: number; label?: string; order: number; token: string; name: string; required: boolean; fallback: string }) {
		this.key = options.key || 0;
		this.label = options.label || '';
		this.order = options.order === undefined ? 1 : options.order;
		this.token = options.token;
		this.name = options.name;
		this.required = options.required;
		this.fallback = options.fallback;
	}
}
